import { Base } from "../../framework/common/base";
import { VehicleMaintenanceDto } from "../../models/vehicleMaintenance/vehicleMaintenance";
import { MaintenanceReminderStatus } from "../../models/vehicleMaintenance/vehicleMaintenanceReminder";

export type ServiceUrgency = "exceeded" | "approaching" | "upcoming";

export const isServiceVisibleForDriver = (m: VehicleMaintenanceDto): boolean => {
    if (m.reminder?.status === MaintenanceReminderStatus.Completed) {
        return false;
    }

    return true;
};

export const isServiceEditableForDriver = (m: VehicleMaintenanceDto): boolean => {
    if (m.reminder?.status === MaintenanceReminderStatus.Completed) {
        return false;
    }

    return true;
};

export const getServiceUrgency = (m: VehicleMaintenanceDto, now = new Date()): ServiceUrgency | null => {
    if (m.reminder?.status) {
        switch (m.reminder.status) {
            case MaintenanceReminderStatus.Exceeded:
                return "exceeded";
            case MaintenanceReminderStatus.Approaching:
                return "approaching";
            case MaintenanceReminderStatus.Incoming:
            case MaintenanceReminderStatus.AwaitingApproval:
            case MaintenanceReminderStatus.Completed:
            default:
                return "upcoming";
        }
    }

    const dateStr = m.reminder?.reminderDate;
    if (!dateStr) {
        return "upcoming";
    }

    const maintenanceDate = Base.dateStrToDayjsIgnoreTimezone(dateStr);
    if (maintenanceDate?.isValid()) {
        if (Base.isAfter(now, maintenanceDate)) {
            return "exceeded";
        }

        const datesBeforeReminderStarts = m.reminder?.datesBeforeReminderStarts;
        if (datesBeforeReminderStarts &&
            Base.dateDiffInDays(now, maintenanceDate) <= datesBeforeReminderStarts
        ) {
            return "approaching";
        }
    }

    return "upcoming";
};
